<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/86vlPl/tc-custom/9781609452612.jpg?1728954376792" alt="This image is the cover for the book Viper, The Commissario Ricciardi Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Viper, The Commissario Ricciardi Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Commissario Ricciardi, “one of the most interesting and well-drawn detectives in fiction,” returns in this historical mystery by the author of <i>By My Hand</i> (<i>The Daily Beast</i>).</b><br/><br/>It is one week before Easter, Naples, 1932. At the high-class brothel in the center of town known as Paradiso, Viper, the most famous prostitute of all, is found dead. Suffocated with a pillow. Her last client swears that when he left her she was alive and well. But when her next client arrived, he found her dead. Who killed her and why? Ricciardi has to untangle a complex knot of greed, frustration, jealousy, and rancor in order to solve the riddle of Viper’s death. As he does so, he will discover no end of conflicting emotions just beneath the surface of a city that lives on passion.<br/><br/>De Giovanni’s mysteries unfold with such sinuous ease that they seem to write themselves. They enchant, surprise; they hold readers enthralled. Commissario Ricciardi, whose dubious gift of being able to see and hear the last seconds in the lives of those who have suffered a violent death, is one of the most fascinating investigators to make his appearance in the world of international crime fiction in recent years. And in <i>Viper</i>, the lustful and boisterous city of Naples has never been more seductive.<br/><br/>“Engaging . . . melancholy Ricciardi, Brigadier Raffaele Maione, and other characters are compellingly drawn. New readers and returning fans should savor this novel like a Neapolitan pastiera.” —<i>Publishers Weekly</i><br/><br/>“De Giovanni is a fantastic discovery and I’m looking forward to reading the series from the start as there’s plenty here to enthrall the reader.” —<i>Crimepieces</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Maurizio de Giovanni, Antony Shugaar
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7ca504a5